import React, { FC, useState } from "react";

import Button from "../../../../../components/elements/Button";
import ConfirmationModal from "../../../../../components/modules/ConfirmationModal";
import api from "../../../../../api";
import { CampaignType } from "../../../../../types/campaignTypes";
import { successToaster } from "../../../../../helpers/toasters";

const archiveCampagin = async (brandgenCampaignId: string) => {
  try {
    await api.archiveCampaign(brandgenCampaignId, { archived: true });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("archiveCampagin error: ", error);
  }
};

type ArchiveCampaignButtonProps = {
  campaignToArchive: CampaignType;
  fetchAndSetCampaings: () => void;
};

const ArchiveCampaignButton: FC<ArchiveCampaignButtonProps> = ({ campaignToArchive, fetchAndSetCampaings }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleOpenConfirmModal = () => setIsConfirmModalOpen(true);
  const handleCloseConfirmModal = () => setIsConfirmModalOpen(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await archiveCampagin(campaignToArchive.brandgenCampaignId);
    await fetchAndSetCampaings();
    successToaster(`Campaign "${campaignToArchive.name}" is successfully archived.`, 5000);
    setIsLoading(false);
  };

  return (
    <>
      <Button
        onClick={handleOpenConfirmModal}
        isLoading={isLoading}
        loaderSize={30}
        disabled={campaignToArchive.active}
      >
        Archive Campaign
      </Button>

      <ConfirmationModal
        isOpen={isConfirmModalOpen}
        confirmButtonLabel="Archive"
        confirmQuestion='The archived campaign will be removed from the campaign selector options. But you can still unarchive it later in the campaigns dashboard. To open the campaigns dashboard click the "View All Campaigns" button.'
        handleConfirm={handleConfirm}
        handleClose={handleCloseConfirmModal}
      />
    </>
  );
};

export default ArchiveCampaignButton;
